// React
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
// KeepSpace Components
import { CubeGrid } from 'components/Loading';
import { createBrowserHistory } from 'history';
import Loader from 'layouts/AdminLayout/components/Loader';
import React, { Suspense } from 'react';

// Redux
import { connect } from 'react-redux';
//Don't Remove this this import is to initialize keepspaceAPI object
import { renderRoutes } from 'react-router-config';

// Router
import { Redirect, Router } from 'react-router-dom';

// Vendor
import Rollbar from 'rollbar';

import { fetchAdmin } from './actions/admin/authenticationActions';
import { apiPath } from './AppConstants';
import { routes } from './routes';

// Material UI
import themeAdmin from './theme/themeAdmin';


const mapStateToProps = (state) => ({
  reduxTokenAuth: state.reduxTokenAuth,
  admin: state.adminAuthReducer,
  isLoading: state.reduxTokenAuth.currentUser.isLoading,
});

const mapDispatchToProps = dispatch => ({
  fetchAdmin: () => dispatch(fetchAdmin()),
});

const history = createBrowserHistory();

export var logger; // Rollbar

class App extends React.PureComponent {

  constructor(props) {
    super(props);
    if (process.env.NODE_ENV !== 'development') {
      logger = new Rollbar({
        accessToken: process.env.REACT_APP_ROLLBAR_POST_CLIENT_ITEM_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: true,
        verbose: true,
        environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
        payload: {
          person: {
            id: this.props.reduxTokenAuth.currentUser.attributes.id,
            email: this.props.reduxTokenAuth.currentUser.attributes.email,
          },
        },
      });
    }

    this.state = {
      username: null,
      apiPath: apiPath,
      showLoader: false,
      rollbar: logger,
      adminLoggedIn: false,
      loadedAdmin: false, // it doesnt determine whether or not admin is logged in. it only fetches the data from localstorage to find admin present or not
    };

    this.updateRollbarConfig = this.updateRollbarConfig.bind(this);
  }

  //setting up state to Let App Decide if user is logged in or not;
  componentDidMount = async () => {
    await this.props.fetchAdmin();
    this.setState({ loadedAdmin: true, adminLoggedIn: this.props.admin.isLoggedIn });
  };

  removeLoader() {
    if (this.state.showLoader) {

      setTimeout(() => {
        this.setState({
          showLoader: false,
        });
      }, 2000);
    }
  }

  updateRollbarConfig() {

    if (process.env.NODE_ENV !== 'development') {
      // We don't want rollbar in development mode, it restricts the devtools ability to determine which line raised an error message
      this.state.rollbar.configure({
        environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
        payload: {
          person: {
            id: this.props.reduxTokenAuth.currentUser.attributes.id,
            email: this.props.reduxTokenAuth.currentUser.attributes.email,
          },
        },
      });
    }
  }

  authoriseAdmin() {
    if (this.props.admin.isLoggedIn) {
      this.removeLoader();
      return <Redirect to={{
        pathname: window.location.pathname,
        state: { referrer: window.location.pathname },
      }}/>;
    } else if (window.location.pathname.split('/')[2] !== 'auth') {
      this.removeLoader();
      return <Redirect to={{
        pathname: '/admin/auth/login',
        state: { referrer: window.location.pathname },
      }}/>;
    }
  }

  render() {
    return (
      <div className="App">
        {/* This is the loading animation that appears on first open */}
        <CubeGrid
          showLoader={this.state.showLoader}
          isLoading={this.props.reduxTokenAuth.currentUser.isLoading || this.props.admin.isLoading || !this.state.loadedAdmin}
        />
        {
          this.state.loadedAdmin &&
          (<ThemeProvider theme={themeAdmin}>
            <MuiPickersUtilsProvider utils={MomentUtils}>

              <Router history={history}>
                {window.location.pathname.split('/')[1] === 'admin' ? this.authoriseAdmin() : null}
                <Suspense fallback={<Loader/>}>
                  {renderRoutes(routes)}
                </Suspense>
              </Router>

            </MuiPickersUtilsProvider>
          </ThemeProvider>)

        }

      </div>
    );
  }

}


export default connect(mapStateToProps, mapDispatchToProps)(App);

